import React from "react";
import { ShieldCheck, Phone } from "lucide-react";

/**
 * Texas STAR+PLUS emblem — recreated as inline SVG/JSX so it stays crisp
 * at any size and matches the look of the official program logo
 * (red "TEXAS" + "PLUS", purple "STAR", red star with purple house silhouette inside).
 */
export const TexasStarPlusEmblem = ({ className = "" }) => {
  return (
    <img
      src="https://customer-assets.emergentagent.com/job_assisted-living-hub-1/artifacts/mi1ws2ph_Your%20paragraph%20text%20%281%29.jpeg"
      alt="We Accept Medicaid / Star+Plus Waiver — Texas STAR+PLUS"
      data-testid="texas-star-plus-emblem"
      className={`block w-full h-auto rounded-2xl shadow-xl ${className}`}
    />
  );
};

const InsuranceSection = () => {
  return (
    <section className="purple-section relative overflow-hidden" data-testid="insurance-section">
      {/* Marquee strip */}
      <div className="border-t border-b border-white/10 py-5 overflow-hidden">
        <div className="marquee-track gap-12 text-white/70 text-sm md:text-base tracking-widest">
          {[...Array(2)].map((_, dup) => (
            <div key={dup} className="flex items-center gap-12 pr-12">
              {["Medicaid", "STAR+PLUS", "Where our home is your home"].map((p, i) => (
                <React.Fragment key={`${dup}-${i}`}>
                  <span className="font-medium whitespace-nowrap">{p}</span>
                  <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--hc-coral)] flex-shrink-0" />
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="container-hc py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left text */}
          <div className="lg:col-span-7">
            <div className="hc-chip chip-purple-on-dark">
              <ShieldCheck size={14} />
              What Sets Us Apart
            </div>

            <h2 className="font-serif-display mt-7 text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-white">
              We proudly accept{" "}
              <span className="italic text-[#c4d8ec]">Medicaid STAR+PLUS.</span>
            </h2>

            <p className="mt-7 max-w-2xl text-lg text-white/80 leading-relaxed">
              Hillcrest Assisted Living is proud to be a participating provider for Medicaid
              STAR+PLUS, helping make assisted living accessible to adults who qualify for
              Medicaid long-term care services.
            </p>

            <p className="mt-5 max-w-2xl text-lg text-white/75 leading-relaxed">
              Our team can help guide families through the eligibility and referral process,
              making the transition to our assisted living as smooth as possible.
            </p>

            <a
              href="tel:9362750222"
              className="mt-9 inline-flex items-center gap-3 bg-white text-[color:var(--hc-navy)] px-6 py-3.5 rounded-full font-semibold hover:bg-[#eaf2fa] transition-colors"
              data-testid="insurance-call-btn"
            >
              <Phone size={18} /> Call (936) 275-0222
            </a>
          </div>

          {/* Right emblem */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <div className="relative max-w-md w-full">
              <div className="absolute -inset-8 rounded-[28px] bg-white/[0.04] blur-2xl" />
              <TexasStarPlusEmblem className="relative" />
              <div className="mt-5 text-center text-sm font-bold tracking-[0.22em] text-white/80">
                APPROVED STAR+PLUS PROVIDER
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InsuranceSection;
